<template>
  <div class="follow">
    <button
      @click.stop="toggleFollow"
      class="follow-btn"
      :class="[
        {
          sm: size === 'sm',
          unfollow: isShopFollowed,
        },
      ]"
    >
      {{ followTextButton }}
    </button>
    <div v-if="withBell" class="bells">
      <font-awesome-icon
        icon="bell-slash"
        size="2x"
        class="action bell"
        v-if="isBellMuted"
        @click.stop="unmuteAlerts"
      />
      <img
        src="../assets/bluebell.png"
        alt=""
        class="action bell active"
        v-if="isBellUnmuted"
        @click.stop="muteAlerts"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FollowButton",
  props: {
    size: {
      type: String,
    },
    shop: {
      type: Object,
    },
    withBell: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isFollowed: "shop/isShopFollowed",
      doesShopAllowAlerts: "shop/doesShopAllowAlerts",
    }),
    isShopFollowed() {
      return this.isFollowed(this.shop.id);
    },
    followTextButton() {
      return this.isShopFollowed ? "unfollow" : "follow";
    },
    followIcon() {
      return this.isShopFollowed ? "check-circle" : "plus-circle";
    },
    isBellUnmuted() {
      return this.isShopFollowed && this.doesShopAllowAlerts(this.shop);
    },
    isBellMuted() {
      return this.isShopFollowed && !this.doesShopAllowAlerts(this.shop);
    },
  },
  methods: {
    toggleFollow() {
      if (this.isShopFollowed) {
        this.$store.dispatch("shop/unfollowShop", this.shop);
        this.$emit("onUnfollow", this.shop);
        this.trackEvent("Shops", "Unfollow", this.shop.name, this.shop.id);
      } else {
        this.$store.dispatch("shop/followShop", this.shop);
        this.$emit("onFollow", this.shop);
        this.trackEvent("Shops", "Follow", this.shop.name, this.shop.id);
      }
    },
    unmuteAlerts() {
      if (!this.doesShopAllowAlerts(this.shop)) {
        this.$store.dispatch("shop/unmuteAlertsForShop", this.shop);
        this.$emit("onUnmute", this.shop);
        this.trackEvent("Shops", "Unmute", this.shop.name, this.shop.id);
      }
    },
    muteAlerts() {
      if (this.doesShopAllowAlerts(this.shop)) {
        this.$store.dispatch("shop/muteAlertsForShop", this.shop);
        this.$emit("onMute", this.shop);
        this.trackEvent("Shops", "Mute", this.shop.name, this.shop.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-btn {
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
  background: $primary1;
  color: white;
  padding: 10px 32px;
  pointer-events: all;
  &.unfollow {
    border-color: $primary1;
    background: white;
    color: $primary1;
    &:hover {
      border-color: $primary1;
    }
  }
  &.sm {
    padding: 7px 20px;
  }
}

.follow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bells {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 2px;
  margin-left: 3px;
  .action {
    margin: 0 8px;
    // width: 0.7em;
    path {
      fill: #2e75d0;
    }
  }
  .bell {
    &.active {
      width: 28px;
    }
  }
  svg {
    width: 28px;
  }
}
</style>
